import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { FormField } from '@/components/ui/form-field';
import { Input } from '@/components/ui/input';
import { useForgotMutation } from '@/features/auth/useAuthMutations';
import { forgotSchema, type ForgotInput } from '@/lib/zodSchemas/auth';

export default function ForgotPage() {
  const mutation = useForgotMutation();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ForgotInput>({
    resolver: zodResolver(forgotSchema),
    defaultValues: { email: '' },
  });

  const onSubmit = handleSubmit(async (values) => {
    await mutation.mutateAsync(values.email);
  });

  return (
    <div>
      <h1 className="font-display text-3xl font-semibold">Recuperar senha</h1>
      <p className="mt-2 text-sm text-(--color-fg-muted)">
        Enviaremos um link de redefinição para o e-mail cadastrado.
      </p>

      {mutation.isSuccess ? (
        <div
          role="status"
          className="mt-6 rounded-md border border-(--color-success) bg-(--color-surface) p-4 text-sm"
        >
          Se o e-mail existir em nossa base, você receberá instruções em alguns minutos.
        </div>
      ) : (
        <form onSubmit={onSubmit} className="mt-8 flex flex-col gap-4" noValidate>
          <FormField id="email" label="E-mail" error={errors.email?.message} required>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              invalid={!!errors.email}
              {...register('email')}
            />
          </FormField>
          <Button type="submit" disabled={isSubmitting || mutation.isPending}>
            {mutation.isPending ? 'Enviando…' : 'Enviar link de redefinição'}
          </Button>
        </form>
      )}

      <p className="mt-6 text-sm">
        <Link to="/login" className="text-(--color-accent) hover:underline">
          Voltar para o login
        </Link>
      </p>
    </div>
  );
}
